<div [matTooltip]="hasAccess() ? '' : 'You do not have permissions. Please contact your system administrator.'">
    <mat-card class="vendor-card" [class.vendor-card--disabled]="!hasAccess()" (click)="hasAccess() && clicked.emit(); $event.stopPropagation()">
        @if (hasAccess()) {
            <div class="vendor-card__badge">Available</div>
        } @else {
            <div class="vendor-card__badge">Unavailable</div>
        }
        <mat-card-header>
            <mat-card-title>
                <img [src]="logo()" [alt]="label()" class="vendor-card__logo" />
                <h3 class="vendor-card__label">{{ label() }}</h3>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="vendor-card__content">
            <p class="vendor-card__description">{{ description() }}</p>
        </mat-card-content>

        <div class="vendor-card__footer">
            <span class="vendor-card__explore">Click to explore</span>
        </div>
    </mat-card>
</div>
